export default __webpack_public_path__ + "static/media/GuitarFingerboard.b7406fa6.svg";